import { useAuthStore } from '@/stores/authStore';
import { useDebugStore, type Plan } from '@/stores/debugStore';
import styles from './DebugModeSwitcher.module.css';

const PLANS: Plan[] = ['free', 'pro', 'team', 'enterprise'];

export function DebugModeSwitcher() {
  const { user } = useAuthStore();
  const { isDebugMode, viewAsPlan, enableDebugMode, disableDebugMode, setViewAsPlan, canDebug } = useDebugStore();

  // Only show for @whss.dev users
  if (!canDebug(user)) {
    return null;
  }

  const handleToggleDebugMode = () => {
    if (isDebugMode) {
      disableDebugMode();
    } else {
      enableDebugMode();
    }
  };

  const handlePlanChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value === 'actual') {
      setViewAsPlan(null);
    } else {
      setViewAsPlan(value as Plan);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.icon}>🔧</span>
        <span className={styles.title}>Debug Mode</span>
        <label className={styles.toggle}>
          <input
            type="checkbox"
            checked={isDebugMode}
            onChange={handleToggleDebugMode}
          />
          <span className={styles.slider} />
        </label>
      </div>
      
      {isDebugMode && (
        <div className={styles.controls}>
          <label className={styles.label}>
            View as:
            <select
              value={viewAsPlan || 'actual'}
              onChange={handlePlanChange}
              className={styles.select}
            >
              <option value="actual">Actual ({user?.plan})</option>
              {PLANS.map((plan) => (
                <option key={plan} value={plan}>
                  {plan.charAt(0).toUpperCase() + plan.slice(1)}
                </option>
              ))}
            </select>
          </label>
          {viewAsPlan && (
            <div className={styles.badge}>
              Viewing as {viewAsPlan}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
